import React from 'react';

type FillColor = string;
type ClassName = string;

interface Props {
  fillColor: FillColor;
  className: ClassName;
}

const defaultProps = {
  className: '',
  fillColor: '#53585E',
};

const CircularArrowIcon = ({
  fillColor,
  className,
}: Props): React.ReactElement<React.ReactNode> => (
  <svg
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g fill="none" fillRule="evenodd">
      <g
        transform="matrix(-1 0 0 1 18 1)"
        fill={fillColor}
        stroke={fillColor}
        strokeWidth="0.5"
      >
        <path d="M17.1818182,7.57894737 L15.9545455,7.57894737 C15.7090909,3.36842105 12.3545455,0 8.18181818,0 C3.92727273,0 0.409090909,3.62105263 0.409090909,8 C0.409090909,12.3789474 3.92727273,16 8.18181818,16 C9.81818182,16 11.4545455,15.4947368 12.7636364,14.4842105 C13.0909091,14.2315789 13.1727273,13.6421053 12.9272727,13.3052632 C12.6818182,12.9684211 12.1090909,12.8842105 11.7818182,13.1368421 C10.7181818,13.8947368 9.49090909,14.3157895 8.18181818,14.3157895 C4.82727273,14.3157895 2.04545455,11.4526316 2.04545455,8 C2.04545455,4.54736842 4.82727273,1.68421053 8.18181818,1.68421053 C11.4545455,1.68421053 14.0727273,4.29473684 14.3181818,7.57894737 L13.0909091,7.57894737 C12.6818182,7.57894737 12.5181818,7.83157895 12.8454545,8.16842105 L14.6454545,10.1894737 C14.9727273,10.5263158 15.4636364,10.5263158 15.7090909,10.1894737 L17.5090909,8.16842105 C17.7545455,7.83157895 17.5909091,7.57894737 17.1818182,7.57894737 Z" />
      </g>
    </g>
  </svg>
);

CircularArrowIcon.defaultProps = defaultProps;

export default CircularArrowIcon;
